module.exports = __webpack_public_path__ + "img/Badge.ded5bb68.svg";